import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService extends BaseApiService {
  protected basePath = '/api/v1';

  /**
   * Submit a purchase suggestion.
   * 
   * @param payload Suggestion details (title, author, patron_id, etc.)
   */
  suggestPurchase(payload: any): Observable<any> {
    return this.post<any>('/suggestions', payload);
  }
}
